<template>
  <button
    :disabled="disabled || spinning"
    :class="[
      'ml-icon-button',
      `ml-icon-button-${variant}`,
      { 'is-disabled': disabled || spinning }
    ]"
    @click.prevent="clicked"
  >
  
    <memlist-spinner size="sm" v-if="spinning" class="mr-2" style="min-height: 24px;"/>
    <span v-else class="svg-icon svg-icon-sm icon-inherit mr-2">
      <i v-if="icon" :class="icon"></i>
      <inline-svg v-if="svg" :src="svg" fill="currentColor"></inline-svg>
    </span>
    <span>{{ text }}</span>
  </button>
</template>


<script>
export default {
  name: 'MemlistSpinnerIconButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    svg: {
      type: String,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'primary',
      validator: v =>
        ['primary', 'primary-outline', 'success', 'success-outline', 'danger', 'danger-outline'].includes(v)
    }
  },
  methods: {
    stop() {
      setTimeout(() => {
        this.spinning = false;
      }, 1000);
    },
    clicked() {
      if (this.spinning) {
        return false;
      }
      
      this.spinning = true;
      this.$emit('click');
    }
  },
  data() {
    return {
      spinning: false
    }
  },
  computed: {
    temp_name() {
      return this.svg ? this.svg : '/assets/svg/certificate.svg';
    },
    resolved_svg() {
      try {
        return this.svg ? require(`@${this.temp_name}`) : null;
      } catch {
        return null;
      }
    }
  }
}
</script>

<style scoped>
.ml-icon-button {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.ml-icon-button-primary {
  background-color: #3699FF;
  color: #fff;
}
.ml-icon-button-primary:hover {
  background-color: #277dd3;
}

.ml-icon-button-primary-outline {
  background-color: transparent;
  color: #3699FF;
  border-color: #3699FF;
}
.ml-icon-button-primary-outline:hover {
  background-color: #e6f0ff;
}

.ml-icon-button-success {
  background-color: #28a745;
  color: #fff;
}
.ml-icon-button-success:hover {
  background-color: #218838;
}

.ml-icon-button-success-outline {
  background-color: transparent;
  color: #28a745;
  border-color: #28a745;
}
.ml-icon-button-success-outline:hover {
  background-color: #e6f9ed;
}

.ml-icon-button-danger {
  background-color: #dc3545;
  color: #fff;
}
.ml-icon-button-danger:hover {
  background-color: #c82333;
}

.ml-icon-button-danger-outline {
  background-color: transparent;
  color: #dc3545;
  border-color: #dc3545;
}
.ml-icon-button-danger-outline:hover {
  background-color: #fbeaec;
}
.icon-inherit {
  font-size: 1em;
  display: inline-flex;
  align-items: center;
}
.ml-icon-button i {
  color: inherit;
}
.ml-icon-button.is-disabled,
.ml-icon-button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;           /* cancels hover styles & clicks */
}

.ml-icon-button.is-disabled:hover,
.ml-icon-button[disabled]:hover {
  background-color: inherit;      /* keep same bg if someone still hovers */
}

/* icon helpers remain unchanged */
.icon-inherit { font-size: 1em; display: inline-flex; align-items: center; }
.ml-icon-button i { color: inherit; }

</style>
